import { render } from "./PlatSetting.vue?vue&type=template&id=625c7ee2&scoped=true"
import script from "./PlatSetting.vue?vue&type=script&lang=js"
export * from "./PlatSetting.vue?vue&type=script&lang=js"

import "./PlatSetting.vue?vue&type=style&index=0&id=625c7ee2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625c7ee2"]])

export default __exports__